export default __webpack_public_path__ + "static/media/sign.2e1e817f.svg";